import { curry } from 'lib/util'

/**
 * Dismisses the software keyboard if executed from a mobile platform.
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const dismissKeyboard = curry((module, component, event) => {
  const eventBus = module[G.ADAPTER][G.EVENTS]
  const eventType = eventBus.type(G.KEYBOARD, G.DONE)

  eventBus.dispatch(eventType, {})
})

export default dismissKeyboard
